import { render, staticRenderFns } from "./InfoAliare.vue?vue&type=template&id=6368361c&scoped=true&"
import script from "./InfoAliare.vue?vue&type=script&lang=ts&"
export * from "./InfoAliare.vue?vue&type=script&lang=ts&"
import style0 from "./InfoAliare.vue?vue&type=style&index=0&id=6368361c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368361c",
  null
  
)

export default component.exports